(() => {
  if (window.fvProductCardMotionInitialized) return;
  window.fvProductCardMotionInitialized = true;
  const initialized = new WeakSet();
  const prepare = async (card) => {
    if (card.dataset.secondaryLoading === 'true' || card.dataset.secondaryReady === 'true') return;
    const image = card.querySelector('.fv-home-product-card__image--secondary');
    if (!image) return;
    card.dataset.secondaryLoading = 'true';
    image.loading = 'eager';
    image.decoding = 'async';
    try {
      await image.decode();
      if (image.naturalWidth && card.isConnected) card.dataset.secondaryReady = 'true';
    } catch {
      // Keep the original product visible if the alternate image cannot load.
    } finally {
      delete card.dataset.secondaryLoading;
    }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      prepare(target);
      observer.unobserve(target);
    });
  }, { rootMargin: '300px' }) : null;
  const initialize = (scope = document) => {
    scope.querySelectorAll('.fv-home-product-card__media--has-secondary').forEach((card) => {
      if (initialized.has(card)) return;
      initialized.add(card);
      card.addEventListener('pointerenter', () => prepare(card));
      card.addEventListener('focus', () => prepare(card));
      if (window.matchMedia('(any-hover: hover)').matches) {
        if (observer) observer.observe(card);
        else prepare(card);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
